
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1640_13182)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.441 14.999h6.118c2.44 0 4.441-1.973 4.441-4.378V7.27c0-1.726-1.434-3.14-3.184-3.14H3.184C1.434 4.131 0 5.545 0 7.271v3.35c0 2.405 2.002 4.378 4.441 4.378zM6.118.001h2.765c.866 0 1.574.79 1.574 1.744v1.753H4.535V1.745c0-.964.708-1.744 1.574-1.744h.009z","fill":"#0E6199"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.117.001h.279c.335 1.083.55 2.258.642 3.497H4.543V1.754C4.543.79 5.251.01 6.117.01V.001zM2.868 14.714c2.477-1.68 4.218-5.534 4.218-10.013 0-.193 0-.377-.01-.57H3.184C1.434 4.131 0 5.545 0 7.271v3.35c0 1.863 1.192 3.46 2.868 4.093z","fill":"#176BA6"}}),_c('path',{attrs:{"d":"M4.115 10.06a.708.708 0 01.028-1.018.733.733 0 011.033.028l1.378 1.422 3.287-3.396a.741.741 0 011.034-.027.716.716 0 01.028 1.018l-3.837 3.966a.733.733 0 01-1.033-.028l-1.909-1.973-.01.009z","fill":"#F7CA03"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1640_13182"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h15v15H0z"}})])])])
          )
        }
      }
    